export default __webpack_public_path__ + "a187f141b81453cb700a3967dd76fff5.svg";